import * as actions from '../actions/category_movies';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
var initialState = {
  isProcessing: false,
  error: null,
  data: {},
  selectItem: []
};
export default reducerWithInitialState(initialState).case(actions.requestCategoryMovies, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: true,
    error: null,
    selectItem: state.data[payload] || []
  });
}).case(actions.successCategoryMovies, function (state, payload) {
  var newData = Object.assign({}, state.data);
  newData[payload.categoryId] = payload.data;
  return Object.assign({}, state, {
    isProcessing: false,
    data: newData,
    selectItem: payload.data
  });
}).case(actions.failureCategoryMovies, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: payload
  });
});